<template>
    <div>
        <Accordion :multiple="true">
            <!-- 'Learning Outcome ' + (1 + index) -->
            <AccordionTab v-for="(learningOutcome, index) in props.learnings"  :key="index" >
                <template #header>
                   <span
                       :class="[
                          learningOutcome.complete === 1
                            ? 'priority-badge status-complete'
                            : (learningOutcome.task?.length > 0
                                ? 'priority-badge status-low'
                                : ''
                              )
                            ]"
                   >
                    {{ generateHeader(learningOutcome, index) }}
                  </span>
                </template>
                <strong>Details:</strong><br />
                <div v-html="learningOutcome.details" class="task-details" />
                <div v-if="learningOutcome.task && learningOutcome.task.length > 0">
                    <ul class="w-full">
                        <li v-for="task in learningOutcome.task" :key="task.id">
                            <router-link :to="{ name: 'TaskDetails', params: { id: task.id } }">
                                {{ task.title }}
                            </router-link>
                        </li>
                    </ul>
                </div>
            </AccordionTab>
        </Accordion>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';

import { themeStore } from '../../../../../store/global-stores';
import { truncateText, removeHtmlTagsFromParagraph } from '../../../../../utilities';

const props = defineProps({
    learnings: {
        type: Array,
    },
});

// generate Accordion headers for learning outcomes list
const generateHeader = (learningOutcome, index) => {
    // 1) Load Theme Name, if themedata is empty load Theme -
    const themeData = themeStore.getThemeDetailsById(learningOutcome?.theme_id);
    const themeName = themeData?.name ?? 'Theme -';
    // 2) Load LearningOutcome details, if there is details then sanitize them and remove tags
    const details = learningOutcome.details;
    const cleanDetails = details ? removeHtmlTagsFromParagraph(details) : 'No Description';
    const count = 1 + index;
    return truncateText(`LO${count}: ${themeName} - ${cleanDetails}`, 50);
};
</script>

<style>
.p-accordion-content {
    width: 100%;
    overflow: scroll;
    margin-bottom: 1rem;
}
.priority-badge {
    border-radius: var(--border-radius);
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-low {
        background: #b3e5fc;
        color: #23547b;
    }

    &.status-medium {
        background: #feedaf;
        color: #8a5340;
    }
    &.status-high {
        background: #ffcdd2;
        color: #c63737;
    }
    &.status-complete {
        background: #c8e6c9;
        color: #256029;     
    }
}
</style>
